// Shared validation utilities for the users feature

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Strict Australian format — for org billing contact fields
export const AU_PHONE_REGEX = /^(\+?61|0)[2-478](\d{8}|\s\d{4}\s\d{4})$/;

// Broader format — for user profile phone fields
export const PHONE_REGEX = /^(\+61[0-9]{9}|0[0-9]{9}|\+?[0-9]{10,15})$/;

export const ABN_REGEX = /^\d{11}$/;

export const WEBSITE_REGEX =
  /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;

export const PASSWORD_REGEX = /^.{6,}$/;

export const VAL_MSG = {
  required: 'This field is required',
  email: 'Please enter a valid email address',
  phone: 'Please enter a valid phone number',
  mobile: 'Please enter a valid mobile number',
  abn: 'ABN must be exactly 11 digits',
  password: 'Password must be at least 6 characters.',
};

/** Validates Australian billing contact phone numbers (strict AU format). */
export const isValidAuPhone = (val: string): boolean => {
  const stripped = val.replace(/[\s\-().+]/g, '');
  return /^(0[2-9]\d{8}|61[2-9]\d{8})$/.test(stripped);
};

/** Validates user profile phone numbers (broader international format). */
export const isValidPhone = (value: string): boolean =>
  PHONE_REGEX.test(value.replace(/[\s\-()]/g, ''));

/** True when an org's billing state means new manual-password seats are free. */
export const isStateA = (org: any): boolean =>
  (!org.billingStatus ||
    org.billingStatus === 'canceled' ||
    org.billingStatus === 'unpaid') &&
  !org.isBillingExempt;
